import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

import { PendingFilesProvider } from './context';
import List from './List';

function PendingFiles() {
  return (
    <PendingFilesProvider>
      <Switch>
        <Route
          render={(props) => (
            <>
              <Can I="list" a="PendingFiles">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="PendingFiles">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </PendingFilesProvider>
  );
}
export default PendingFiles;
